import { useTranslation } from 'react-i18next';

export function KpiFallback() {
  const { t } = useTranslation();
  return (
    <div className="row w-100 m-0 my-auto p-0">
      <div className="col my-auto text-center">
        <p className="text-basic">{t('kpi.error')}</p>
      </div>
    </div>
  );
}
